/* Release 6.5, the side cart (15_Spec_Release_6_5_Cart.md section 3).
   Loads on every page from snippets/au-r65-side-cart.liquid.

   1. After a confirmed add (au-purchase sends a cancelable
      "australia:purchase_added"), it opens with the item, unless another
      dialog is open; then the add behaves as before. On /cart the cart
      section refreshes instead and the side cart never opens.
   2. A click on the header bag opens it (without scripts the link goes to
      /cart).
   3. Content comes from the Section Rendering API (/?sections=au-r65-side-cart),
      so prices, the band and the add on come from Liquid.
   4. Dialog: focus to the title, kept inside; Esc, the close button and the
      scrim close it; focus goes back to what opened it; page scroll locked;
      a short slide, none under reduced motion (CSS).
   5. Events: sidecart_open, sidecart_checkout, sidecart_view_cart,
      cart_ship_state, cart_gap_add, cart_complement_add. No personal data. */
(() => {
  if (window.AUSideCart) return;
  const shell = document.querySelector('[data-au-r65-side]');
  if (!shell) return;
  const dialog = shell.querySelector('[data-au-r65-side-dialog]');
  const title = shell.querySelector('[data-au-r65-side-title]');
  const slot = shell.querySelector('[data-au-r65-side-slot]');
  const announce = shell.querySelector('[data-au-r65-side-announce]');
  const root = shell.dataset.root || '/';
  const onCart = /\/cart\/?$/.test(location.pathname);
  const blockers = 'dialog[open], [aria-modal="true"]:not([data-au-r65-side-dialog]), cart-drawer.is-open, [data-av-mobile-drawer][open], #shopify-pc__banner, #shopify-privacy__banner-div, [data-av-cookie-banner], [data-av-consent-banner]';
  const track = (name, payload = {}) => { try { window.AVAnalytics?.custom?.(name, payload); } catch (_) { /* analytics are optional */ } };
  const visible = (el) => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) && getComputedStyle(el).visibility !== 'hidden';
  const blocked = () => [...document.querySelectorAll(blockers)].some(visible);
  let opener = null;
  let openerHost = null;
  let shownVariant = null;
  let busy = false;

  const focusables = () => [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])')].filter(visible);

  /* The add buttons say the label, the product and the price (as on the 6.3 cards).
     au-r65-cart.js calls it on the cart page too. */
  const nameButtons = (scope) => scope.querySelectorAll('[data-au-r65-addon], [data-au-r65-four]').forEach((card) => {
    const button = card.querySelector('[data-au-purchase-submit]');
    const product = card.dataset.name || card.querySelector('a[href*="/products/"]:not([aria-hidden])')?.textContent.replace(/\s+/g, ' ').trim() || '';
    const label = button?.querySelector('[data-au-purchase-label]')?.textContent.trim().split(' · ')[0];
    if (!button || !label) return;
    button.dataset.auNameTemplate = `${label}, ${product}, [[price]]`;
    const price = button.querySelector('[data-au-purchase-total]')?.textContent.trim();
    if (price) button.setAttribute('aria-label', `${label}, ${product}, ${price}`);
  });

  const shipState = (scope) => {
    const band = scope.querySelector('[data-au-r65-band]');
    if (band) track('cart_ship_state', { reached: band.dataset.reached === 'true', remaining: Number(band.dataset.remaining) || 0 });
  };

  // Release 6.9 (spec 27, 4.4): opening the side cart clears a Pix flag left from an earlier checkout.
  const clearPixFlag = (content) => {
    if (!content?.hasAttribute('data-au-r69-pix-flag')) return;
    content.removeAttribute('data-au-r69-pix-flag');
    fetch(`${root}cart/update.js`.replace('//cart', '/cart'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _au_pix: '' } }) }).catch(() => { /* checkout removes it again when Pix is not selected */ });
  };

  async function load() {
    const response = await fetch(`${root}?sections=au-r65-side-cart`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error('side_cart_failed');
    const html = (await response.json())['au-r65-side-cart'] || '';
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-au-r65-side-content]');
    if (!next) throw new Error('side_cart_missing');
    slot.replaceChildren(next);
    const lines = [...next.querySelectorAll('[data-au-r65-side-line]')];
    const line = lines.find((el) => el.dataset.variantId === String(shownVariant)) || lines[0];
    if (line) {
      line.hidden = false;
      const others = next.querySelector('[data-au-r65-side-others]');
      if (others && line.dataset.others) { others.textContent = line.dataset.others; others.hidden = false; }
    }
    nameButtons(next);
    try { window.AUPurchase?.init?.(next); } catch (_) { /* the native forms still post to /cart */ }
    return next;
  }

  function lock(on) {
    document.documentElement.classList.toggle('au-r65-locked', on);
  }

  async function open(source, variantId, from) {
    if (busy) return;
    busy = true;
    opener = from || document.activeElement;
    openerHost = opener?.closest?.('[data-au-r63-card], [data-au-r64-item], [data-au-purchase], li, article') || null;
    shownVariant = variantId || null;
    title.textContent = source === 'add' ? shell.dataset.titleAdd : shell.dataset.titleHeader;
    try {
      const content = await load();
      shell.hidden = false;
      lock(true);
      requestAnimationFrame(() => shell.classList.add('is-open'));
      title.focus({ preventScroll: true });
      track('sidecart_open', { source });
      shipState(content);
      clearPixFlag(content);
    } catch (_) {
      // the panel could not load: the bag page, as before Release 6.5
      location.assign(`${root}cart`.replace('//', '/'));
    } finally {
      busy = false;
    }
  }

  function close() {
    if (shell.hidden) return;
    shell.classList.remove('is-open');
    shell.hidden = true;
    lock(false);
    // au-purchase lets the add button work again before focus goes back to it
    document.dispatchEvent(new CustomEvent('australia:sidecart_closed'));
    const usable = (el) => el?.isConnected && !el.disabled && visible(el);
    let target = usable(opener) ? opener : null;
    if (!target && openerHost?.isConnected) target = [...openerHost.querySelectorAll('[data-au-purchase-submit], button, a[href]')].find(usable) || null;
    target?.focus?.({ preventScroll: true });
    opener = null;
    openerHost = null;
  }

  /* On /cart: the section refreshes after an add (au-cart.js does the fetch) */
  async function refreshCart(cart) {
    const page = document.querySelector('au-cart[data-av-cart-section]');
    if (!page?.refresh) { location.reload(); return false; }
    try {
      await page.refresh(cart?.item_count ?? 0, {});
      requestAnimationFrame(() => {
        document.querySelector('au-cart[data-av-cart-section] h1')?.focus({ preventScroll: false });
        const live = document.querySelector('[data-au-r65-announce]');
        if (live) live.textContent = shell.dataset.titleAdd;
      });
      return true;
    } catch (_) {
      location.reload();
      return true;
    }
  }

  document.addEventListener('australia:purchase_added', (event) => {
    const { form, variantId, handle, cart } = event.detail || {};
    const addon = form?.closest?.('[data-au-r65-addon]') || document.querySelector(`[data-au-r65-addon] [form="${form?.id}"]`)?.closest('[data-au-r65-addon]');
    if (addon) track(addon.dataset.auR65Addon === 'gap' ? 'cart_gap_add' : 'cart_complement_add', addon.dataset.auR65Addon === 'gap' ? { handle, price: Number(addon.dataset.price) || 0 } : { handle });
    if (onCart) {
      event.preventDefault();
      void refreshCart(cart);
      return;
    }
    if (!shell.hidden && dialog.contains(form)) {
      event.preventDefault();
      shownVariant = variantId;
      void load().then((content) => { announce.textContent = shell.dataset.titleAdd; shipState(content); }).catch(() => {});
      return;
    }
    if (blocked()) return;
    event.preventDefault();
    void open('add', variantId, form?.querySelector('[type="submit"]') || document.querySelector(`[type="submit"][form="${form?.id}"]`));
  });

  /* Header bag */
  if (!onCart) document.querySelectorAll('a[data-av-cart-count-link]').forEach((link) => link.setAttribute('aria-haspopup', 'dialog'));
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-av-cart-count-link]');
    if (link && !onCart && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      void open('header', null, link);
      return;
    }
    if (shell.hidden) return;
    if (event.target.closest('[data-au-r65-side-close]')) { close(); return; }
    if (event.target.closest('[data-au-r65-side-checkout]')) {
      track('sidecart_checkout', { item_count: Number(slot.querySelector('[data-au-r65-side-content]')?.dataset.count) || 0 });
      // the same begin_checkout the cart page sends, with every line in the bag
      try {
        const items = [...slot.querySelectorAll('[data-au-r65-side-line][data-av-analytics-item]')].map((line) => window.AVAnalytics?.itemFromNode?.(line)).filter(Boolean);
        if (items.length) window.AVAnalytics?.standard?.('begin_checkout', items, {}, { dedupeKey: `begin_checkout:side:${items.map((i) => `${i.item_id}x${i.quantity}`).join(',')}`, ttl: 5000 });
      } catch (_) { /* analytics are optional */ }
    }
    if (event.target.closest('[data-au-r65-side-view]')) track('sidecart_view_cart');
    const step = event.target.closest('[data-au-r65-side-qty]');
    if (step && !busy) {
      const line = step.closest('[data-au-r65-side-line]');
      const plus = step.dataset.auR65SideQty === 'plus';
      // the variant's quantity rules: steps of the increment, below the minimum the line goes, never above the maximum
      const now = Number(line.dataset.quantity) || 0;
      const min = Math.max(1, Number(line.dataset.min) || 1);
      const inc = Math.max(1, Number(line.dataset.step) || 1);
      const max = Number(line.dataset.max) || 0;
      let quantity = plus ? now + inc : now - inc;
      if (!plus && quantity < min) quantity = 0;
      if (plus && max > 0 && quantity > max) return;
      const error = line.querySelector('[data-au-r65-side-error]');
      if (error) error.textContent = '';
      busy = true;
      // Release 6.8: on a panel out of date the line may be gone, and Shopify would match its key to a kit
      // holding that product and change the kit. Read the bag first; if the line is gone, post nothing.
      const post = async () => {
        const read = await fetch(`${root}cart.js`.replace('//cart', '/cart'), { headers: { Accept: 'application/json' } });
        if (!read.ok) throw new Error('cart_read_failed');
        const current = await read.json();
        if (!(current.items || []).some((item) => item.key === line.dataset.key)) return { cart: current, gone: true };
        const r = await fetch(`${root}cart/change.js`.replace('//cart', '/cart'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.dataset.key, quantity }) });
        if (!r.ok) throw new Error('change_failed');
        return { cart: await r.json(), gone: false };
      };
      let lineGone = false;
      post()
        .catch((e) => { throw Object.assign(e, { change: true }); })
        .then(({ cart, gone }) => {
          lineGone = gone;
          try {
            const item = window.AVAnalytics?.itemFromNode?.(line);
            const delta = Math.abs(quantity - now);
            if (item && delta && !gone) window.AVAnalytics?.standard?.(quantity > now ? 'add_to_cart' : 'remove_from_cart', { ...item, quantity: delta }, {}, { dedupeKey: `side_qty:${item.item_id}:${delta}:${Date.now()}`, ttl: 0 });
          } catch (_) { /* analytics are optional */ }
          document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cartCount: cart.item_count } }));
          // the bag changed; if the panel cannot reload, the bag page shows it
          return load().catch(() => { location.assign(`${root}cart`.replace('//', '/')); return null; });
        })
        .then((content) => {
          if (!content) return;
          const shown = content.querySelector('[data-au-r65-side-line]:not([hidden])');
          const band = content.querySelector('[data-au-r65-band-line]');
          // the line was gone: the panel now shows another line, so focus the title, never that line's stepper
          announce.textContent = (lineGone ? [band?.textContent] : [shown?.querySelector('.au-r65-side__qty')?.textContent, band?.textContent]).filter(Boolean).join('. ');
          ((lineGone ? null : shown?.querySelector(`[data-au-r65-side-qty="${step.dataset.auR65SideQty}"]`)) || title).focus({ preventScroll: true });
        })
        .catch((e) => {
          if (!e?.change) return;
          // the quantity did not change: say so next to the stepper, and keep focus there
          const message = slot.querySelector('[data-au-r65-side-content]')?.dataset.qtyError || '';
          if (error && message) error.textContent = message;
          step.focus({ preventScroll: true });
        })
        .finally(() => { busy = false; });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (shell.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) { event.preventDefault(); title.focus(); return; }
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === title)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  dialog.addEventListener('focusout', () => {
    requestAnimationFrame(() => { if (!shell.hidden && !dialog.contains(document.activeElement)) title.focus({ preventScroll: true }); });
  });
  window.addEventListener('pageshow', (event) => { if (event.persisted) close(); });

  window.AUSideCart = Object.freeze({ open: (source = 'header') => open(source, null, document.activeElement), close, nameButtons });
})();
